import { getStatusPalette } from "../components/calendar-container/modal/helpers/normalizedColorsCalendar";
import { DateTime } from "luxon";
import { resolveCompanyWallTime } from "./companyWallTime";

export const toCompanyWallDate = (value, timeZone) => {
  const dateTime = DateTime.fromISO(value, { setZone: true }).setZone(timeZone);
  if (!dateTime.isValid) return value;
  return new Date(dateTime.year, dateTime.month - 1, dateTime.day, dateTime.hour, dateTime.minute, dateTime.second, dateTime.millisecond);
};

export const toCompanyInstantFromWallDate = (date: Date, timeZone: string) => {
  const result = resolveCompanyWallTime(date, timeZone);
  return result.kind === "valid" ? result.choices[0].instant : null;
};

export const mappedDataForCalendar = (item, timeZone = "UTC") => {
  if (!item) return null;

  const job = item.job;
  if (!job) return null;

  const quote = job.quote;
  const status = item.status || job.status;

  const client = item?.client || job?.client;
  const company = item?.company || job?.company;
  const coverageArea = item?.coverageArea || job?.coverageArea;
  const workforce = item?.workforce;

  const pallette = getStatusPalette(status);

  return {
    id: item?.uid || job?.id,
    title: job?.alias || "Job Service",
    start: toCompanyWallDate(item.startDate, timeZone),
    end: toCompanyWallDate(item.endDate, timeZone),

    extendedProps: {
      jobId: job?.id,
      quoteId: job.quoteId,
      status,
      color: pallette?.color,
      workType: quote?.event?.mode || "Job",
      client: {
        firstName: client?.firstName || "",
        lastName: client?.lastName || "",
        alias: client?.alias || null,
        avatar: client?.avatar || null,
        name: `${client?.firstName ?? ""} ${client?.lastName ?? ""}`.trim(),
      },

      company: {
        businessName: company?.businessName ?? "",
        businessPhone: company?.businessPhone ?? "",
      },

      coverageArea: {
        address: coverageArea?.address ?? "",
        city: coverageArea?.city ?? "",
        state: coverageArea?.state ?? "",
      },

      quote: {
        quoteId: quote?.id,
        startDate: quote?.startDate,
        endDate: quote?.endDate,
      },

      job: {
        alias: job?.alias,
        clientUid: job?.clientUid,
        scopeOfWorkUid: job?.scopeOfWorkUid,
        isVisit: job?.isVisit,
        type: job?.type,
        status: job?.status,
        coverageAreaId: job?.coverageAreaId,
        companyId: job?.companyId,
      },

      workforce:
        workforce?.map((member) => ({
          firstName: member.firstName || member.alias?.split(" ")[0] || "",
          lastName: member.lastName || member.alias?.split(" ")[1] || "",
          avatar: member.avatar || null,

          WorkforcesByJobs: {
            jobWorkforceRole: member.workforceRole || member.role || "employee",
          },

          WorkforcesByJobEvents: {
            status:
              member?.WorkforcesByJobEvents?.status ||
              member?.status ||
              null,
            startAt:
              member?.WorkforcesByJobEvents?.startAt ||
              member?.startAt ||
              null,
            endAt:
              member?.WorkforcesByJobEvents?.endAt ||
              member?.endAt ||
              null,
            workforceUid:
              member?.WorkforcesByJobEvents?.workforceUid ||
              member?.uid ||
              null,
            jobEventUid:
              member?.WorkforcesByJobEvents?.jobEventUid ||
              item?.uid ||
              null,
          },
        })) || [],

      event: {
        startDate: item.startDate,
        endDate: item.endDate,
        duration: job?.quote?.event?.eventConfig?.duration,
        mode: quote?.event?.mode || "SINGLE_EXECUTION",
        typeName: quote?.event?.typeName || "child-event",
        frequency: quote?.event?.frequency || null,
        uid: item.uid,
      },
    },
  };
};
